<div>
  <div class="prose">
    <h1>API Invoices</h1>
  </div>

  @if (errorFetchingInvoices) {
    <div class="mt-4">
      <p class="text-error">{{ errorFetchingInvoices }}</p>
    </div>
  } @else if (loadingInvoices) {
    <div class="mt-4 flex justify-center">
      <div class="loading loading-spinner loading-lg"></div>
    </div>
  } @else {
    <!-- Pending API Invoices Section -->
    @if (pendingApiInvoices.length > 0) {
      <div class="mt-8">
        <div class="prose mb-4">
          <h2 class="ml-6">Pending Invoices</h2>
        </div>
        <div
          class="hidden overflow-x-auto rounded-lg border border-base-content/20 sm:block"
        >
          <table
            class="table table-zebra table-pin-rows table-pin-cols table-lg static"
          >
            <thead class="text-base font-medium">
              <tr>
                <td>Order #</td>
                <td>Transaction Month</td>
                <td>Total Amount</td>
                <td>Created Date</td>
                <td class="w-36"></td>
              </tr>
            </thead>
            <tbody>
              @for (invoice of pendingApiInvoices; track invoice) {
                <tr
                  class="cursor-pointer text-base"
                  (click)="navigateToApiInvoice(invoice)"
                >
                  <td>{{ invoice.number }}</td>
                  <td>
                    {{
                      getDisplayTransactionMonth(invoice.transaction_yyyymm)
                        | date: 'MMMM, yyyy'
                    }}
                  </td>
                  <td>{{ invoice.total_amount | currency }}</td>
                  <td>
                    {{ invoice.created_at | date: 'MM/dd/yyyy, hh:mmaa' }}
                  </td>
                  <td class="w-32">
                    <button class="btn btn-primary btn-sm w-32">Pay Now</button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <!-- Mobile Pending API Invoices -->
        <div class="sm:hidden">
          @for (invoice of pendingApiInvoices; track invoice) {
            <div
              class="my-2 w-full rounded-lg border border-base-content/20 p-4"
              (click)="navigateToApiInvoice(invoice)"
            >
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Order #:</p>
                <p>{{ invoice.number }}</p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Transaction Month:</p>
                <p>
                  {{
                    getDisplayTransactionMonth(invoice.transaction_yyyymm)
                      | date: 'MMMM, yyyy'
                  }}
                </p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Total Amount:</p>
                <p>{{ invoice.total_amount | currency }}</p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Created Date:</p>
                <p>
                  {{ invoice.created_at | date: 'MM/dd/yyyy, hh:mmaa' }}
                </p>
              </div>
            </div>
          }
        </div>
      </div>
    }

    <!-- No invoices message -->
    @if (pendingApiInvoices.length === 0) {
      <div class="mt-8">
        <p class="italic text-base-content/80">
          No pending API invoices found for this account.
        </p>
      </div>
    }

    <div class="mt-8">
      <p class="my-5 text-xl font-bold">
        To view your completed API invoices, go to
        <a
          class="link-primary underline underline-offset-4"
          [routerLink]="['/receipts']"
          >Receipts</a
        >
      </p>
    </div>
  }
</div>
